<template>
    <div>
        <div class="col-lg-12 mb-4">
            <div class="applicant-nav-tabs">
                <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" v-for="(tab,index) in tabs">
                        <a
                            :class="[`nav-link `, {'active': activeTabIndex === index}]"
                            :id="`tab-${index}`"
                            data-toggle="tab"
                            :href="`#${tab}`"
                            role="tab"
                            aria-controls="home"
                            aria-selected="false"
                            @click="setActiveTab(tab)"
                        >
                            {{ tab }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-12 mb-4">
            <div class="box">
                <div class="tab-content" id="myTabContent">

                    <div v-for="(tab,index) in tabs"
                         :class="[`tab-pane fade`, {'show active': activeTabIndex === index}]"
                         :id="tab"
                         role="tabpanel"
                         :aria-labelledby="`tab-${index}`"
                    >
                        <component
                            :is="getComponentName(tab)"
                            :userInfo="user"
                            :view-rates="true"
                        ></component>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmployeeSupport from "./EmployeeSupport.vue";
import EmployeeFaq from "./EmployeeFaq.vue";
import EmployeeReferences from "../CommonForms/EmployeeReferences.vue";
import EmployeeTimeSheet from "./EmployeeTimeSheet.vue";
import EmployeeUniforms from "./EmployeeUniforms.vue";
import EmployeeShiftBoards from "./EmployeeShiftBoards.vue";
import EmployeeAvailability from "./EmployeeAvailability.vue";
import EmployeePersonal from "./EmployeePersonal.vue";
import EmployeeStatus from "./EmployeeStatus.vue";
import TabsHandler from "../../../../../../resources/js/mixins/TabsHandler";


export default {
    name: 'TabsContainer',
    props: {
        userStatus: {
            type: String
        },
        user: {
            type: Object
        }
    },
    components: {
        EmployeeSupport,
        EmployeeFaq,
        EmployeeReferences,
        EmployeeTimeSheet,
        EmployeeUniforms,
        EmployeeShiftBoards,
        EmployeeAvailability,
        EmployeePersonal,
        EmployeeStatus
    },
    data() {
        return {
            selectedTab: null,
            activeTabIndex: 0,
            tabs: ['Status', 'Personal', 'Availability', 'Shift Boards', 'Uniforms', 'Time Sheet', 'Faq', 'Support']
        }
    },
    methods: {
        getComponentName(tabName) {
            return `Employee${tabName.replace(/\s+/g, '')}`;
        },

        setActiveTab(tabName) {
            this.activeTabIndex = this.tabs.indexOf(tabName);
            window.history.pushState({tab: tabName}, "", `?tab=${tabName}`);
        },

        getActiveTab() {

            const urlParams = new URLSearchParams(window.location.search);
            const tab = urlParams.get('tab');

            if (null === tab) {
                return;
            }

            for (let i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i] === tab) {
                    this.activeTabIndex = i;
                }
            }
        },

    },
    mounted() {
        if (this.userStatus === 'pending') {
            this.tabs = ['Status', 'Personal', 'Availability', 'Shift Boards']
            this.getActiveTab();
        } else if (this.userStatus === 'active') {
            this.tabs = ['Personal', 'Availability', 'Shift Boards', 'Uniforms', 'Time Sheet', 'Faq', 'Support']
            this.getActiveTab();
        } else if (this.userStatus === 'inactive') {
            this.tabs = ['Personal', 'Availability', 'Shift Boards']
            this.getActiveTab();
        }
    }

}

</script>

<style scoped>

</style>
